import Button from "../../../../../../components/button/button.jsx";
import {memo, useEffect, useRef, useState} from "react";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import ModalBody from "../../../../../../components/modal/modal-body.jsx";
import ModalFooter from "../../../../../../components/modal/modal-footer.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {FaEraser, FaSearch} from "react-icons/fa";
import CapturePlaceTable from "./select-item-table.jsx";
import {useFormContext} from "react-hook-form";
import {useGlobalKey} from "../../../../../../hooks/use-global-key.js";
import projectUtils from "../../../../../../utils/project-utils.js";
import {createBasicSetup, lanesLane, lanesRoute} from "../../../utils/lanes-form-utils.js";
import {useLanesFormDefault} from "../../../hooks/use-form-default-options.jsx";

const initialFilter = {
  description: "",
}
const SelectItemModal = ({columnDefs, type, isDisabled = false}) => {
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState(initialFilter);
  const [selectedItem, setSelectedItem] = useState(null);
  const gridRef = useRef(null);
  const {setValue} = useFormContext();
  const {handleType} = useLanesFormDefault(setValue);

  useEffect(() => {
    if(!showModal) return;
    setFilters(initialFilter);
  }, [showModal]);

  const clear = () => {
    if(!gridRef.current) return;
    setFilters(initialFilter);
    gridRef.current.setFilterModel({});
  }

  const filter = () => {
    if(!gridRef.current) return;

    const filterModel = {};

    if(filters.description){
      filterModel.description = {
        filterType: "text",
        type: "contains",
        filter: filters.description,
      }
    }

    gridRef.current.setFilterModel(filterModel);
  }

  useGlobalKey("Enter", filter);
  useGlobalKey("Escape", clear);

  const submit = () => {
    if(!selectedItem) {
      projectUtils.swalErrorMessage("", "Selecione um ponto de coleta.");
      return;
    }
    if(type === "capturePlace"){
      const selectedType = selectedItem.laneType ?? "";

      setValue("capturePlace", selectedItem, { shouldDirty: true });
      setValue("capturePlaceSnapshot", selectedItem, { shouldDirty: true });

      if(selectedItem.mobile){
        setValue("route", lanesRoute, { shouldDirty: true });
        setValue("routeSnapshot", null, { shouldDirty: true });
        setValue("lane", {...lanesLane, type: selectedType}, { shouldDirty: true });
        setValue("smartcaptureDriver.back", createBasicSetup(), { shouldDirty: true });
        setValue("smartcaptureDriver.forward", createBasicSetup(), { shouldDirty: true });
        setValue("lane.type", handleType({value: selectedType}), { shouldDirty: true });
      }
    } else {
      setValue("route", selectedItem, { shouldDirty: true });
      setValue("routeSnapshot", selectedItem, { shouldDirty: true });
    }
    setShowModal(false);
    setSelectedItem(null);
  }

  const openModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  }

  return(
    <>
      <Button onClick={openModal} disabled={isDisabled}>Selecionar {type === "capturePlace" ? "ponto" : "sentido"}</Button>
      <Modal open={showModal} setOpen={setShowModal} title={`Selecione um ${type === "capturePlace" ? "ponto de coleta" : "sentido"}`} className="w-6/12" isCloseClick={false}>
        <ModalBody>
          <div className="flex flex-col gap-2">
            <div className="flex gap-4">
              <InputForm
                id="selectCapturePlaceName"
                label="Nome"
                value={filters.description}
                onChange={({target}) => setFilters(prev => ({...prev, description: target?.value}))}
                classNameWrapper="flex-1"
              />
              <div className="flex gap-2">
                <Button type="button" title="Limpar" target="primary-outline" onClick={clear}><FaEraser/></Button>
                <Button type="button" title="Buscar" onClick={filter}><FaSearch/></Button>
              </div>
            </div>
            <div className="h-[calc(100vh-300px)]">
              <CapturePlaceTable gridRef={gridRef} selectedItem={selectedItem} setSelectedItem={setSelectedItem} columnDefs={columnDefs} type={type}/>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" onClick={submit}>Selecionar</Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default memo(SelectItemModal);